import ErrorInner from "../components/ErrorInner";
import Preloader from "../helper/Preloader";
import Animation from "../helper/Animation";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { useAllDataContext } from "../context/AllDataContext";
import { useEffect } from "react";
import { fetchSchoolDetails } from "../api/SchoolDetailsApi";
import FooterThree from "../components/FooterThree";

const ErrorPage = () => {
  const { setLoading } = useLoader();
  const { schoolDetailsData, setSchoolDetailsData } = useSchoolDetailsContext();
  const { setAllData } = useAllDataContext();

  FetchAllApi({ schoolDetailsData, setAllData, setLoading });
  useEffect(() => {
    if (schoolDetailsData.length === 0) {
      Promise.all([fetchSchoolDetails()])
        .then(([schoolDetailsData]) => {
          setSchoolDetailsData(schoolDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [schoolDetailsData.length, setSchoolDetailsData]);

  return (
    <>
      <Preloader />
      <Animation />
      <HeaderOne />
      <ErrorInner />
      <FooterThree />
    </>
  );
};

export default ErrorPage;
